import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { style } from '@angular/animations';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-multiSelect',
  templateUrl: './multiSelect.component.html',
  styleUrls: ['./multiSelect.component.css'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]

})
export class MultiSelectComponent implements OnInit {

  @Input() label: String;
  @Input() model:any;
  @Input() style:any;
  @Input() apiService: any;
  @Input() options:any;
  @Input() name: string;
  @Output() onSelect = new EventEmitter<string>();
  @Output() onModelChange = new EventEmitter<number>();
  formName: string = '';

  constructor() { }
  onChange(event) {this.onSelect.emit(event.value.value) }
  ngOnInit() {
    this.formName = this.name ;
    this.apiService.list().subscribe(
      res => {
        this.options = res;
      });
  }
  modelChange($event) {
    this.onModelChange.emit($event);
  }
}